import { render, staticRenderFns } from "./OrderBarcodeScan.vue?vue&type=template&id=35b88122&scoped=true&"
import script from "./OrderBarcodeScan.vue?vue&type=script&lang=js&"
export * from "./OrderBarcodeScan.vue?vue&type=script&lang=js&"
import style0 from "./OrderBarcodeScan.vue?vue&type=style&index=0&id=35b88122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b88122",
  null
  
)

export default component.exports